import { RoommembersApi } from '../api-clients';
import { wrap } from '../wrap';

export const roommemberApi = {
  index: wrap(RoommembersApi, RoommembersApi.prototype.indexRoomMember),
  create: wrap(RoommembersApi, RoommembersApi.prototype.createRoomMember),
  stop: wrap(RoommembersApi, RoommembersApi.prototype.stopRoomMember),
};
